<template>
  <div class="cooperation">
    <div v-if="lists.length>0" class="cooperation-li">
      <div v-for="(item,index) in lists" :key="index">
        <div class="title">项目标题：{{item.cpx_order_name}}</div>
        <div class="title-li">
          <span class="c-2a2 w-300">创建时间：{{item.create_time}}</span>
          <span class="c-2a2 pl-20">合作联系人{{item.order_adid_name}}</span>
        </div>
        <!-- <div class="title-li">
          <span>合作联系人：</span>
          <span class="c-2a2">{{item.order_adid_name}}</span>
        </div> -->
        <div class="title-li">
          <span class="c-2a2 w-300">推广预算：¥{{item.budget_money}}</span>
          <span class="c-2a2 pl-20">结算方式：{{item.settlement_source==1?'CPX联盟':'非联盟（合同等）'}}</span>
        </div>
        <div class="title-t">投放商品（{{item.kol_goods_num}}）</div>

        <div class="goods-box clearfix" v-if="item.kol_goods_num>0">
          <div
            v-for="(items,index) in item.goods_list"
            :key="index"
            class="item pointer"
            @click="goLaunchgoods(items)"
          >
            <img class="goods-pic" :src="items.goods_img" />
            <div class="item-name c-999">{{items.goods_name}}</div>
            <div class="item-store">
              <span>店铺：</span><span class="c-333" v-if="items.store_name.length<12">{{items.store_name.slice(0,12)}}</span>
              <span v-else>
                <el-tooltip
                  class=""
                  effect="dark"
                  :content="items.store_name"
                  placement="top-start"
                >
                  <span class="c-333">{{items.store_name.slice(0,12)}}...</span>
                </el-tooltip>
              </span>
              <img class="logo" v-if="items.platform=='tianmao'" src="../../assets/my/tianmao.png" />
              <img class="logo" v-if="items.platform=='suning'" src="../../assets/my/suning.png" />
              <img class="logo" v-if="items.platform=='jingdong'" src="../../assets/my/jds.gif" />
              <img class="logo" v-if="items.platform=='kaola'" src="../../assets/my/kaola.png" />
              <img class="logo" v-if="items.platform=='taobao'" src="../../assets/my/tb.png" />
            </div>
          </div>
        </div>
        <div v-else class="not">暂无数据~</div>
        <div class="item-down" @click="showGoodslist(index,1)" v-if="item.kol_goods_num>6">
          <i :class="item.goods_show?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
          <span class="mr-10">{{item.goods_show?'收起':'剩余商品信息'}}</span>
        </div>
        <div class="title-t">合作达人（{{item.kol_user_num}}）</div>
        <div class="goods-box clearfix" v-if="item.kol_user_num>0">
          <div v-for="(ite,index) in item.user_list" :key="index" class="item">
            <img class="goods-pics" :src="ite.head_portrait" />
            <div class='kol-b'>
            <div class="kol-li">
              <span v-if='ite.nickname.length<12'>{{ite.nickname}}</span>
                <span v-else>
                <el-tooltip
                  class=""
                  effect="dark"
                  :content="ite.nickname"
                  placement="top-start"
                >
                  <span class="c-333">{{ite.nickname.slice(0,12)}}...</span>
                </el-tooltip>
              </span>
              <span v-if="ite.check_status">
                <span v-if="ite.check_status==1">(待确认报价)</span>
                <span v-if="ite.check_status==2">(待上线)</span>
                <span v-if="ite.check_status==3">(已完成)</span>
              </span>
            </div>
            <div v-if="ite.kol_time_begin">
              <div class="kol-li">带货时间：</div>
              <div class="kol-li c-666">{{ite.kol_time_begin}}-</div>
              <div class="kol-li c-666">{{ite.kol_time_end}}</div>
            </div>
            </div>
          </div>
        </div>
        <div v-else class="not">暂无数据~</div>
        <div class="item-down" @click="showGoodslist(index,2)" v-if="item.kol_user_num>6">
          <i :class="item.user_show?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
          <span class="mr-10">{{item.user_show?'收起':'剩余达人信息'}}</span>
        </div>
      </div>
    </div>

    <div class="not-tip" v-else>
      <img src="../../assets/auth/noauth.png" class="auth-tip" />
      <div>暂无数据～</div>
    </div>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
  </div>
</template>

<script>
import "./tool.css";
import pagePagination from "@/components/page_pagination.vue"
export default {
  name: "cooperation",
  components:{
    pagePagination
  },
  data() {
    return {
      api: {
        getCooperationKolGoodsList: "/home/getCooperationKolGoodsList"
      },
      pageData: {
        count: 0,
        page: 1,
        offset: 10
      },
      lists: [], //总数据
      goods_show: false
    };
  },
  // watch: {
  //   // 对路由变化作出响应...
  //   $route: {
  //     handler: function() {
  //      this.getCooperationKolGoodsList();
  //     },
  //     immediate: true
  //   }
  // },
  created() {
    this.getCooperationKolGoodsList();
  },
  methods: {
    getCooperationKolGoodsList() {
      let _this = this;
      let data = {
        page: _this.pageData.page,
        page_size: _this.pageData.offset
      };
      this.$http({
        method: "GET",
        url: _this.api.getCooperationKolGoodsList,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.lists = res.data.data;
          if (res.data.data.length == 0) {
            return false;
          }
          let lists = _this.lists;
          lists.forEach((item, index) => {
            item.goods_show = false;
            item.user_show = false;
            item.kol_goods_list = [];
            item.kol_user_list = [];
            let kol = item.kol_goods;
            let user = item.kol_user;
            if (item.kol_goods_num > 0) {
              for (let i in kol) {
                item.kol_goods_list.push(kol[i]);
              }
            }
            if (item.kol_user_num > 0) {
              for (let i in user) {
                item.kol_user_list.push(user[i]);
              }
            }
            item.kol_user_list.forEach((ite, inx) => {
              if (ite.kol_time_begin) {
                ite.kol_time_begin = ite.kol_time_begin.replace(/\-/g, ".");
                ite.kol_time_end = ite.kol_time_end.replace(/\-/g, ".");
              }
            });
          });
          lists.forEach((item, index) => {
            item.goods_list = [];
            item.user_list = [];
            if (item.kol_goods_list.length > 6) {
              item.goods_list = item.kol_goods_list.slice(0, 6);
              item.goods_min = item.kol_goods_list.slice(0, 6);
              item.goods_max = item.kol_goods_list;
            } else {
              item.goods_list = item.kol_goods_list;
            }
            if (item.kol_user.length > 6) {
              item.user_list = item.kol_user_list.slice(0, 6);
              item.user_min = item.kol_user_list.slice(0, 6);
              item.user_max = item.kol_user_list;
            } else {
              item.user_list = item.kol_user_list;
            }
          });
          _this.pageData.count = res.data.total;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    showGoodslist(index, type) {
      //type 1.商品 2 达人
      let list = this.lists;
      list.forEach((item, indexs) => {
        if (index == indexs) {
          if (type == 1) {
            item.goods_show = !item.goods_show;
            if (item.goods_show) {
              item.goods_list = item.goods_max;
            } else {
              item.goods_list = item.goods_min;
            }
          }
          if (type == 2) {
            item.user_show = !item.user_show;
            if (item.user_show) {
              item.user_list = item.user_max;
            } else {
              item.user_list = item.user_min;
            }
          }
          this.$forceUpdate();
        }
      });
    },
    goLaunchgoods(datas) {
      this.$router.push({
        name: "launchgoods",
        query: {
          kolgsid: datas.kolgsid
        }
      });
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getCooperationKolGoodsList();
    }
  }
};
</script>

<style scoped>
.c-333 {
  color: #333;
}
.mr-10 {
  margin-right: 10px;
}
.cooperation {
  margin-top: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  border-left:2px solid #666;
  padding-left:5px;
}
.title-li {
  display: flex;
  font-size: 13px;
  color: #151151;
  line-height: 20px;
  margin-top: 20px;
  text-indent: 20px;
}
.c-2a2 {
  color: #2a2a2a;
}
.title-t {
  font-size: 14px;
  color: #333;
  /* font-weight: bold; */
  margin: 27px 0 29px 0;
}
.goods-pic {
  display: block;
  width:100px;
  height: 100px;
  margin-bottom: 9px;
}
.goods-pics{
  display: block;
  width:90px;
  height: 90px;
  margin-bottom: 9px;
}
.flex {
  display: flex;
}
.clearfix::after {
  display: block;
  content: "";
  clear: both;
}
.item {
  float: left;
  width: 126px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 40px 30px 0;
  /* padding:10px; */
  /* border:1px solid #dedede; */
  /* height:242px; */
}
.item:nth-child(6n) {
  margin-right: 0;
}
.item-name {
  font-size: 12px;
  color: #666;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
}
.item-store {
  font-size: 12px;
  line-height: 20px;
  color: #333;
  text-align: left;
  width:124px;
}
.c-999 {
  color: #999;
}
.logo {
  width: 15px;
  height: 15px;
  margin: 0 0 -2px 5px;
  border-radius: 2px;
  /* background: url('../../assets/my/') no-repeat;
  background-size:cover; */
}
.item-down {
  display: flex;
  font-size: 14px;
  color: #333;
  align-items: center;
  flex-direction: row-reverse;
  margin: 16px 0;
  cursor: pointer;
}
.kol-li {
  position: relative;
  width: 100%;
  font-size: 12px;
  color: #333;
  line-height: 20px;
  text-align: left;
}
.c-666 {
  color: #666;
}
.not {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #999;
}
.auth-tip {
  display: block;
  width: 290px;
  height: 270px;
}
.not-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 400px;
  font-size: 14px;
  color: #999;
}
.cooperation-li {
  border-bottom: 1px solid #dedede;
  margin-top: 20px;
}
.pl-20{
  padding-left:20px;
}
.w-300{
  width:300px;
}
.pointer{
  cursor: pointer;
}
.kol-b{
  height:100px;
  overflow: hidden;
}
</style>